/**
 * HSS Sort — client-side companion to the [hss_video_sort] shortcode.
 *
 * Replaces FacetWP's own native Sort facet markup with an HSS-owned
 * <select> that reads/writes through HSSCore instead of firing FacetWP's
 * own independent change handler. The problem this fixes: FacetWP's native
 * facet markup calls FWP.fetch() using only FWP.facets as FacetWP itself
 * last knew it — and the HSS-owned facets (_model_filter, _keyword_search,
 * _feature_category) are asserted into FWP.facets by HSSCore.navigate(),
 * never by FacetWP's own facet templates. A sort change routed entirely
 * through FacetWP's own JS could therefore fire a refresh that silently
 * dropped whatever Y/M/T/keyword/feature filters were already applied.
 *
 * Every change here instead calls HSSCore.resolveInitialState(config) first
 * to pick up the CURRENT year/model/trim/keyword/feature state, merges in
 * the newly picked sort value, and hands the whole thing to
 * HSSCore.navigate() — the same single call the chip bar and configurator
 * use — so sort changes and never overwrites the rest, and the rest never
 * overwrites sort (see hss-core.js v1.8 and hss-frontend.js v1.12).
 *
 * Supports multiple instances on one page (querySelectorAll + class, same
 * pattern as hss-selection.js) rather than assuming a single #id, since
 * nothing else about this control needs to be singleton.
 */
(function () {
	'use strict';

	function currentSelectValue(config) {
		var state = window.HSSCore.parseUrlState(config);
		return state.sort || '';
	}

	/**
	 * Re-syncs every <select> on the page to whatever sort is currently in
	 * the URL. Called on boot and on every 'facetwp-loaded' event — the
	 * same no-reload sync path the chip bar and configurator already rely
	 * on — so a sort change made from one instance (or a Clear All fired
	 * from the chip bar/configurator elsewhere on the page) is reflected
	 * everywhere without a page reload.
	 */
	function syncAll(selects, config) {
		var value = currentSelectValue(config);
		selects.forEach(function ($select) {
			if ($select.value !== value) {
				$select.value = value;
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		if (typeof window.HSSCore === 'undefined' || typeof hssSortConfig === 'undefined') return;

		var $selects = Array.prototype.slice.call(document.querySelectorAll('.hss-sort-select'));
		if (!$selects.length) return;

		// Ensure `flat` is populated even on a page where neither the chip
		// bar nor the configurator is present — HSSBar.init()/the
		// configurator's boot are what normally call this, and neither is
		// guaranteed to be on a page that only has [hss_video_sort].
		window.HSSCore.buildFlat(window.hssTree, window.hssFeatureCategories);

		$selects.forEach(function ($select) {
			// [hss_video_sort search_page="…"] override — same pattern as
			// the chip bar/configurator: hssSortConfig.searchPage is
			// localized once, globally, before this shortcode's own atts
			// exist, so a per-instance override is read off the wrapper's
			// data attribute instead and applied to a copy of the config,
			// per <select>, so the admin-settings URL stays the default
			// for every other instance on the page.
			var config  = hssSortConfig;
			var $wrap   = $select.closest('.hss-sort-wrap');
			if ($wrap && $wrap.dataset.searchPage) {
				config = Object.assign({}, hssSortConfig, { searchPage: $wrap.dataset.searchPage });
			}

			$select.addEventListener('change', function () {
				// Picks up whatever Year/Model/Trim/Keyword/Feature is
				// currently applied (URL first, FWPVFM/feature cookie
				// fallback — same resolution order every other HSS widget
				// uses) and layers the newly chosen sort on top, so this
				// never overwrites those filters.
				var state = window.HSSCore.resolveInitialState(config);
				state.sort = $select.value || null;
				window.HSSCore.navigate(config, state);
			});
		});

		syncAll($selects, hssSortConfig);

		if (window.jQuery) {
			window.jQuery(document).on('facetwp-loaded', function () {
				syncAll($selects, hssSortConfig);
			});
		}
	});
}());
